import { render, staticRenderFns } from "./Checkboxs.vue?vue&type=template&id=09f82618&scoped=true&"
import script from "./Checkboxs.vue?vue&type=script&lang=ts&"
export * from "./Checkboxs.vue?vue&type=script&lang=ts&"
import style0 from "./Checkboxs.vue?vue&type=style&index=0&id=09f82618&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f82618",
  null
  
)

export default component.exports